/**
 * @generated SignedSource<<3b140c6cf2c37588f18c1f2f641b879a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SideMenu_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FormRateSearch_viewer" | "RecentSearches_viewer">;
  readonly " $fragmentType": "SideMenu_viewer";
};
export type SideMenu_viewer$key = {
  readonly " $data"?: SideMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SideMenu_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SideMenu_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FormRateSearch_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecentSearches_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "de3a488189e5b60479bf96d48816556a";

export default node;
